var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimsAssisted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 49.875,
    viewBox: "0 0 57 49.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1901",
    "data-name": "Group 1901",
    transform: "translate(-4186.665 -972.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48322",
    "data-name": "Path 48322",
    d: "M4188.541,982.759a.89.89,0,0,1,.528-.447s25.122-8.147,25.548-8.219l.062-.02a3.474,3.474,0,0,1,2.069.17l.923.3-.154-.465a2.68,2.68,0,0,0-2.553-1.831,2.71,2.71,0,0,0-.83.13l-25.611,8.24a2.659,2.659,0,0,0-1.571,1.338,2.616,2.616,0,0,0-.15,2.022l10.554,31.808v-5.658l-8.863-26.713A.845.845,0,0,1,4188.541,982.759Z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48323",
    "data-name": "Path 48323",
    d: "M4301.2,1228.839l1.666,5.023a1.777,1.777,0,0,0,.571.818v-4.755l-.541-1.632.541-.174v-1.872l-1.1.355A1.767,1.767,0,0,0,4301.2,1228.839Z",
    transform: "translate(-106.08 -235.442)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48324",
    "data-name": "Path 48324",
    d: "M4541.749,1021.032a2.679,2.679,0,0,0-2.553,1.831l-.428,1.289h1.877l.241-.727a.9.9,0,0,1,.862-.61.926.926,0,0,1,.285.045l4.016,1.292h5.821l-9.292-2.989A2.7,2.7,0,0,0,4541.749,1021.032Z",
    transform: "translate(-326.376 -45.221)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48325",
    "data-name": "Path 48325",
    d: "M4419.978,1150.932a.55.55,0,0,1,.142-.182.755.755,0,0,1,.489-.173c.046,0,.085,0,.086,0a1.356,1.356,0,0,1,.309.106.48.48,0,0,1,.189.167,1.241,1.241,0,0,0,.266.273.894.894,0,0,0,1.065-.081.708.708,0,0,0,.246-.533.62.62,0,0,0-.044-.224,1,1,0,0,0-.083-.168,2.047,2.047,0,0,0-.81-.729,2.326,2.326,0,0,0-.718-.231,2.768,2.768,0,0,0-1.431.12,2.314,2.314,0,0,0-.731.448,2.09,2.09,0,0,0-.486.661,1.893,1.893,0,0,0-.177.809v1.243a1.745,1.745,0,0,0,.193.809,2.14,2.14,0,0,0,.506.641,2.356,2.356,0,0,0,.737.422,2.652,2.652,0,0,0,.894.15h.076a2.469,2.469,0,0,0,1.148-.264,2.011,2.011,0,0,0,.8-.72,1.788,1.788,0,0,0,.083-.166.586.586,0,0,0,.047-.23.7.7,0,0,0-.249-.539.921.921,0,0,0-1.09-.07,1.4,1.4,0,0,0-.238.259.57.57,0,0,1-.2.17,1.04,1.04,0,0,1-.3.1h-.075a.751.751,0,0,1-.516-.187.554.554,0,0,1-.143-.19.5.5,0,0,1-.044-.241v-1.22A.492.492,0,0,1,4419.978,1150.932Z",
    transform: "translate(-214.699 -163.943)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48326",
    "data-name": "Path 48326",
    d: "M4487.638,1149.35a.917.917,0,0,0-1.174,0,.692.692,0,0,0-.249.532v3.852a.77.77,0,0,0,.252.52.856.856,0,0,0,.595.22h2.609a.851.851,0,0,0,.58-.218.708.708,0,0,0,0-1.067.85.85,0,0,0-.58-.219h-1.778v-3.088A.692.692,0,0,0,4487.638,1149.35Z",
    transform: "translate(-277.662 -163.967)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48327",
    "data-name": "Path 48327",
    d: "M4551.96,1154.253a.88.88,0,0,0,.57.194h.009a.854.854,0,0,0,.565-.225.679.679,0,0,0,.23-.507v-2.57a1.751,1.751,0,0,0-.193-.809,2.14,2.14,0,0,0-.506-.641,2.333,2.333,0,0,0-.737-.423,2.655,2.655,0,0,0-1.794.015,2.325,2.325,0,0,0-.731.448,2.091,2.091,0,0,0-.487.661,1.989,1.989,0,0,0-.186.809v2.531a.646.646,0,0,0,.256.512.9.9,0,0,0,1.139-.017.678.678,0,0,0,.249-.517v-.632h1.362v.655A.648.648,0,0,0,4551.96,1154.253Zm-1.614-2.637v-.449a.5.5,0,0,1,.053-.224.573.573,0,0,1,.143-.183.749.749,0,0,1,.219-.126.739.739,0,0,1,.524,0,.784.784,0,0,1,.228.136.557.557,0,0,1,.143.191.568.568,0,0,1,.052.242v.411Z",
    transform: "translate(-335.583 -163.953)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48328",
    "data-name": "Path 48328",
    d: "M4620.827,1154.387a.7.7,0,0,0,.242-.53v-3.844a.692.692,0,0,0-.239-.523.9.9,0,0,0-1.182,0,.693.693,0,0,0-.24.523v3.844a.7.7,0,0,0,.242.53.875.875,0,0,0,.6.218A.854.854,0,0,0,4620.827,1154.387Z",
    transform: "translate(-401.124 -164.089)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48329",
    "data-name": "Path 48329",
    d: "M4656.127,1153.71v-2.819a1.728,1.728,0,0,0-.18-.685,1.962,1.962,0,0,0-1.036-.946,2.083,2.083,0,0,0-1.477-.013,2.758,2.758,0,0,0-.424.21,2.537,2.537,0,0,0-.437-.214,2.083,2.083,0,0,0-1.486.027,2.107,2.107,0,0,0-.625.393,1.8,1.8,0,0,0-.418.57,1.567,1.567,0,0,0-.152.671v2.807a.706.706,0,0,0,.243.538.927.927,0,0,0,1.185,0,.707.707,0,0,0,.242-.538v-2.746a.257.257,0,0,1,.088-.2.337.337,0,0,1,.441,0,.252.252,0,0,1,.088.2v2.746a.708.708,0,0,0,.243.538.916.916,0,0,0,1.177,0,.706.706,0,0,0,.243-.538v-2.746a.247.247,0,0,1,.09-.2.334.334,0,0,1,.439,0,.257.257,0,0,1,.088.2v2.746a.706.706,0,0,0,.242.538.875.875,0,0,0,.6.218.855.855,0,0,0,.582-.216A.7.7,0,0,0,4656.127,1153.71Z",
    transform: "translate(-429.38 -163.949)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48330",
    "data-name": "Path 48330",
    d: "M4446.65,1260.668a1.787,1.787,0,0,0-1.781-1.783h-18.705a1.787,1.787,0,0,0-1.781,1.783v5.347a1.787,1.787,0,0,0,1.781,1.782h18.705a1.787,1.787,0,0,0,1.781-1.782Zm-1.781,5.347h-18.705v-5.347h18.705Z",
    transform: "translate(-220.348 -265.695)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48331",
    "data-name": "Path 48331",
    d: "M4357.337,1090.8v24.063a.891.891,0,1,0,1.782,0V1090.8a.892.892,0,0,1,.891-.891h26.72a.892.892,0,0,1,.891.891v16.511l.723-.875,1.059-1.375V1090.8a2.676,2.676,0,0,0-2.672-2.674h-26.72A2.676,2.676,0,0,0,4357.337,1090.8Z",
    transform: "translate(-158.201 -107.413)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48332",
    "data-name": "Path 48332",
    d: "M4359.119,1538.22v-3.565a.8.8,0,0,1,0-.446.952.952,0,0,0-1.782.446v3.565a2.676,2.676,0,0,0,2.672,2.674h14.256a2.654,2.654,0,0,1,.107-.733l.312-1.05h-14.675A.892.892,0,0,1,4359.119,1538.22Z",
    transform: "translate(-158.201 -520.076)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48333",
    "data-name": "Path 48333",
    d: "M4722.6,1616.717h2.7a2.675,2.675,0,0,0,2.445-1.6Z",
    transform: "translate(-496.779 -595.899)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48334",
    "data-name": "Path 48334",
    d: "M4821.069,1098.734a.9.9,0,0,1,.365.228,2.661,2.661,0,0,1,2.032.457,2.63,2.63,0,0,0-.28-1.044,2.661,2.661,0,0,0-1.571-1.338l-9.444-3.038a4.429,4.429,0,0,1,.6,2.067Z",
    transform: "translate(-579.802 -112.857)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48335",
    "data-name": "Path 48335",
    d: "M4789.848,1525.277a3.047,3.047,0,0,1-.445,1.622v.381a4.458,4.458,0,0,1-2.456,3.977,2.672,2.672,0,0,0,2.132-1.8l2.635-7.944a3.61,3.61,0,0,1-1.44.406A9.873,9.873,0,0,0,4789.848,1525.277Z",
    transform: "translate(-556.421 -509.136)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48336",
    "data-name": "Path 48336",
    d: "M4637.55,1199.648l-8.538,7.436a.085.085,0,0,1-.084-.008l-3.682-3.84a.2.2,0,0,1-.022-.159l13.152-15.915a.891.891,0,0,0-1.373-1.136l-13.17,15.937a1.96,1.96,0,0,0-.145,2.125,10.584,10.584,0,0,1-4.871,1.074c-.159,0-.308,0-.445-.007h-.035a1.259,1.259,0,0,0-1.181.844l-3.7,12.453a.476.476,0,0,0,.636.631l12.27-3.81a1.309,1.309,0,0,0,.86-1.232,9.908,9.908,0,0,1,1.113-5.284,1.831,1.831,0,0,0,1.825-.31l8.558-7.452a.891.891,0,0,0-1.17-1.345Zm-12.111,14.044-7.087,2.2,3.9-3.906c.023,0,.046.007.07.007a1.337,1.337,0,1,0-1.336-1.337c0,.024.005.046.007.07l-4.818,4.821,2.555-8.6h.084a11.907,11.907,0,0,0,6.083-1.494l2.054,2.142A11.1,11.1,0,0,0,4625.439,1213.692Z",
    transform: "translate(-395.578 -197.86)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48337",
    "data-name": "Path 48337",
    d: "M4826.73,1321.647l-5.9,5.682a.891.891,0,1,0,1.235,1.285l5.9-5.682a.891.891,0,1,0-1.235-1.285Z",
    transform: "translate(-587.575 -323.641)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48338",
    "data-name": "Path 48338",
    d: "M4443.107,1418.186h.092c.121,0,.25.007.389.007a10.364,10.364,0,0,0,2.783-.37.888.888,0,0,0-.723-.374h-20.375a.891.891,0,0,0,0,1.782h15.557A3.075,3.075,0,0,1,4443.107,1418.186Z",
    transform: "translate(-220.348 -412.674)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48339",
    "data-name": "Path 48339",
    d: "M4440.008,1466.236h-14.734a.891.891,0,0,0,0,1.783h14.205Z",
    transform: "translate(-220.348 -457.895)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48340",
    "data-name": "Path 48340",
    d: "M4424.383,1515.913a.891.891,0,0,0,.891.891h13.147l.529-1.782h-13.676A.891.891,0,0,0,4424.383,1515.913Z",
    transform: "translate(-220.348 -503.117)",
    fill: "#bebebe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsAssisted);
export default __webpack_public_path__ + "static/media/claims-assisted.d07ea9b83d2159eaed25122b262ae5df.svg";
export { ForwardRef as ReactComponent };